module.exports = __webpack_public_path__ + "static/media/3close upIMG_3494.603d9381.jpg";